import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.link = this.element.querySelector('[data-click-target]')
    if (!this.link) return
    this.href = this.link.getAttribute('href')
  }

  click(event) {
    if (!this.link) return
    if (event.metaKey || event.ctrlKey) return

    // Ignore clicks on buttons/links inside the row, except the intended link
    if (event.target.tagName === 'BUTTON' || event.target.tagName === 'A') {
      if (event.target !== this.link && !this.link.contains(event.target)) {
        return
      }
    }

    window.location = this.href
  }

  mousedown(event) {
    if (!this.link) return
    if (event.metaKey || event.ctrlKey) {
      window.open(this.href, '_blank')
      event.preventDefault()
    }
  }
}
